import { Editor, Element } from 'slate';
import { getNext } from './get-next';

export function getBlockNext<T extends Element>(editor: Editor, options?: Parameters<typeof getNext>[1]) {
    return getNext<T>(editor, {
        ...options,
        block: true,
    });
}
